// TODO: Fix typings

type Payload = {
  options: any
  option: string | number | null
}

const useSelected = () => {
  const selected = (payload: Payload) => {
    for (let i = 0; i < payload.options.length; i++) {
      if (Array.isArray(payload.options[i])) {
        const child: any = selected({
          options: payload.options[i],
          option: payload.option,
        })

        if (child) {
          return child
        }
      }

      if (payload.options[i].value === payload.option) {
        return payload.options[i]
      }
    }
  }

  return selected
}

export default useSelected
